import { Box, IconProps } from "@chakra-ui/react";
import { Logo, NavItem } from "../components";

type IProps = {
  menuItems: IMenuItem<IconProps>[];
};

const DashboardLeft = ({ menuItems }: IProps) => {
  return (
    <Box
      borderRight={"1px solid"}
      h={"100%"}
      borderColor={"neutral.900"}
      p={"1rem"}
    >
      <Logo />
      <Box display={"flex"} flexDirection={"column"} gap={".5rem"}>
        {menuItems.map((item) => (
          <NavItem type="side" key={item.path} item={item} />
        ))}
      </Box>
    </Box>
  );
};

export default DashboardLeft;
